module.exports = "/assets/data/64d486865db6d175f0f387d6b7128b11-EN10.data.json";